import React from 'react';

export function OmdEmptyHint({ children = 'Keine Angaben verfügbar.' }: { children?: React.ReactNode }) {
  return <p className="text-sm text-app-text-subtle">{children}</p>;
}
